const HighRes = '[data-high-res-thumb]';
const HighResClass = 'high-res';
const DefaultResClass = 'default-res';
export function checkThumbnails() {
    let thumbnails = document.querySelectorAll('[data-adage-video-thumbnail]');

    [].forEach.call(thumbnails, (thumbnail) => initThumbnail(thumbnail));
}

function initThumbnail(container: HTMLElement) {
    let hiResImg: HTMLImageElement = container.querySelector(HighRes) as HTMLImageElement;

    let hiResWidth = hiResImg ? hiResImg.naturalWidth : 0;
    if (hiResWidth < 140) {
        container.classList.add(DefaultResClass);
    }
    else {
        container.classList.add(HighResClass);
    }
}